import { useLocation } from "@reach/router";
import { getUnlocalizedPath } from "../helpers/path";

const useUnlocalizedLocationPath = (): string => {
  const { pathname } = useLocation();
  return getUnlocalizedPath(pathname);
};

export default useUnlocalizedLocationPath;
